import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import SimpleResultPDF from './SimpleResultPDF';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/Store';

const PDFDownload: React.FC = () => {
  const questions = useSelector((state: RootState) => (state as any).questions || {});
  const childInfo = useSelector((state: RootState) => (state as any).childInfo || {});
  
  return (
    <>
    {questions && childInfo && Object.keys(childInfo).length > 0 && ( 
    <PDFDownloadLink
      document={<SimpleResultPDF results={questions} childInfo={childInfo} />}
      fileName={`mchat-followup-${new Date().toISOString().split('T')[0]}.pdf`}
      className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all"
    >
      {({ blob, url, loading, error }) => (
        <span>
          {loading ? 'Generating PDF..' : 'Download PDF'}
        </span>
      )}
    </PDFDownloadLink>
  )}
  </>
  );
}

export default PDFDownload;